<template>
  <div class="main-body">
    <div>
      <farewell-page v-if="urlParams === 'farewell'"></farewell-page>
      <home-page v-else></home-page>
    </div>
  </div>
</template>

<script>
import "./assets/css/reset.css";
import configFn from "./env";
import farewellPage from "./views/farewell/index.vue";
import homePage from "./views/home/index.vue";
import { getQueryVariable } from "./utils/index.js";
export default {
  name: "XesMallFooter",
  components: { homePage, farewellPage},
  props: {
    feedBackUrl: {
      type: String,
      default: "//www.xueersi.com/StudentFeedback/apply/",
    },
  },
  data() {
    return {
      config: null,
    };
  },
  computed: {
    urlParams() {
      return getQueryVariable("name");
    },
  },
  created() {
    this.config = configFn(0);
  },
};
</script>

<style lang="scss" scoped>
@import "./assets/css/index.scss";
</style>
<style>
body {
}
</style>
